@if (showContent()) {
  <button
    tabindex="0"
    type="button"
    class="background-button dummy-background"
    (click)="onHeaderButtonClick()"
    (keydown)="onHeaderButtonKeydown($event)"
    aria-label="Close side navigation background">
  </button>
}
<div class="panel-container product-customizer">
  <div class="pdp-sidenav-content" #sidePanel [class.pdp-sidenav-show]="showContent()" [class.pdp-sidenav-content-left]="side()==='left'" [class.pdp-sidenav-content-right]="side()==='right'" [class.zip-confirm-width]="zipConfirm()" [attr.aria-hidden]="!showContent() ? 'true' : 'false'">
    <div class="panel-description-content" [ngClass]="panelContainerClass()">
      <div class="fixed-header" [class.flex-row]="side()==='right'" [class.right-side-panel]="side()==='right'" [class.flex-row-reverse]="side()==='left'" [class.left-side-panel]="side()==='left'">
        <div class="side-nav-title">
          <ng-content select="myCustomHeader"></ng-content>
        </div>
        <button
          type="button"
          class="btn btn-close"
          aria-label="close"
          data-cy="common-side-nav-back-btn"
          (click)="onHeaderButtonClick()"
          (keydown)="onHeaderButtonKeydown($event)"
          >
          <homefield-icon
            class="hmf-header-bold-s hmf-header-bold-m hover-pointer"
            name="sign-cancel-outline"
            aria-hidden="true">
          </homefield-icon>
        </button>
      </div>
      <div [ngClass]="panelBodyClass()">
        <ng-content select="myCustomBody"></ng-content>
      </div>
    </div>
  </div>
  @if (isFormEmpty()) {
      <div class="hmf-display-flex hmf-flex-wrap hmf-mx-0 service-section">
        <!-- Customizer Button-->
        <div class="wrapper-button">
          <button
            type="button"
            [class.hmf-display-flex]="addFlexBox()"
            [class.hmf-display-inline-block]="!addFlexBox()"
            (click)="onCoverButtonClick()"
            (keydown)="onCoverButtonKeydown($event)"
            tabindex="0"
            aria-label="Open side navigation panel"
            class="background-button"
          >
            <ng-content select="myPanelCover"></ng-content>
          </button>
        </div>
      </div>
  }
</div>

